type Day = '2-digit' | 'numeric'
type Month = '2-digit' | 'numeric' | 'short' | 'long'
type Year = 'numeric' | '2-digit'
type Week = 'long'
interface DateFormatterOptions {
	day?: Day
	month?: Month
	year?: Year
	timeZone?: string
	weekday?: Week
}

export interface DateFormatterProps {
	dateString: string
	locale: string
	options?: DateFormatterOptions
}

export function dateFormatter({
	dateString,
	locale,
	options = {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
	},
}: DateFormatterProps): string {
	return new Date(dateString).toLocaleDateString(locale, options)
}
